import script from "./PropertyCustomerTasksLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./PropertyCustomerTasksLink.vue?vue&type=script&setup=true&lang=ts"

import "./PropertyCustomerTasksLink.vue?vue&type=style&index=0&id=2fa0b41e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa0b41e"]])

export default __exports__